<template>
  <v-container class="grey lighten-5">
    <h2>Zertifikatssuche</h2>
    <br/>
    <v-text-field v-model="searchTerm" label="Username oder Zertifikats ID"/>
    <v-btn class="ma-1" color="info" :loading="loading"
           :disabled="loading || searchTerm.length===0"
           @click.stop="search()">
      Suchen
      <template v-slot:loader>
        <span class="custom-loader">
          <v-icon light>mdi-cached</v-icon>
        </span>
      </template>
    </v-btn>

    <v-data-table
        :headers="standardHeaders"
        :items="items"
        item-key="courseRunId"
        :items-per-page="50"
        class="elevation-1"
    >
      <template v-slot:item.certificate="{ item }">
        <v-btn @click="downloadCertificate(item.certificateFileName)"
               class="ma-2"
               outlined
               x-small
               fab
               color="indigo"
        >
          <v-icon>mdi-download</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.date="{item}">
        {{ item.date | moment("DD.MM.YYYY HH:mm") }}
      </template>
      <template v-slot:item.upload="{item}">
        <input type="file" @change="(event) => {uploadFile(event, item)}" ref="file">
      </template>
    </v-data-table>

    <v-snackbar :timeout="5000" :value="error" color="error" left shaped top app>{{ errorText }}</v-snackbar>
    <v-snackbar :timeout="5000" :value="success" color="primary" left shaped top app>{{ successText }}</v-snackbar>

  </v-container>

</template>

<script>


export default {
  name: "SuperAdminCertSearch",
  data: () => ({
    items: [],
    loading: false,
    searchTerm: "",
    error: false,
    success: false,
    progress: 0,
    errorText: "",
    successText: "",
  }),
  computed: {
    standardHeaders() {
      let headers = [
        {text: "Username", value: "username"},
        {text: "Kursname", value: "courseName"},
        {text: "KursLaufID", value: "courseRunId"},
        {text: "Zertifikatsdateiname", value: "certificateFileName"},
        {text: "Datum", value: "date"},
        {text: "Manuell", value: "manualCreated"},
        {text: "Zertifikat", value: "certificate", sortable: false},
        {text: "ZertifikatsUpload", value: "upload", sortable: false}
      ]
      return headers;
    }
  },
  methods: {
    uploadFile(event, licenceUser) {
      this.$httpLicenseApi.upload(event.target.files[0], licenceUser.courseRunId, () => {
        this.successText = "Hochgeladen.";
        this.success = true;
        setTimeout(() => this.success = false, 3000);
      }, (error) => {
        this.errorText = "Fehler: " + error;
        this.error = true;
        setTimeout(() => this.error = false, 5000);
      })
    },
    downloadCertificate(link) {
      this.$httpDownloadApi.download("https://lms.behrendtonline.com/behrendt/api/certificates/"+link, "Zertifikat");
    },
    search() {
      this.loading = true;
      this.$httpCertificateApi.getByTerm(this.searchTerm, (data) => {
        this.loading = false;
        this.items = data;
      }, () => {
        this.loading = false;
        this.errorText = "Fehler."
        this.error = true;
        setTimeout(() => this.error = false, 5000);
      })
    },
    fileSelected(file) {
      this.file = file;
    },
  },
  mounted() {
  }
}
</script>

<style scoped>

</style>
